import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Loading = ({ fullScreem = false, noBackground = false }) => {
  return (
    <div className={`lds-contailer ${fullScreem ? 'full-screem' : ''} ${noBackground ? 'no-background' : ''}`}>
      <div className={`lds-ring ${fullScreem ? 'full-screem' : ''}`}>
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

Loading.propTypes = {
  fullScreem: PropTypes.bool,
  noBackground: PropTypes.bool,
};

export default Loading;
